/* eslint consistent-return: 0, no-else-return: 0*/
import * as userTypes from './user';

export const DISMISS_MESSAGE = 'Message/DISMISS_MESSAGE';

export function dismissMessage() {
  return { 
    type: DISMISS_MESSAGE
   };
}

/*
 * Message store for global messages, i.e. Network messages / Redirect messages
 * that need to be communicated on the page itself. Ideally
 * messages/notifications should appear within the component to give the user
 * more context. - My 2 cents.
 */
export default function message(state = {
  message: '',
  type: 'SUCCESS'
}, action = {}) {
  switch (action.type) {
    case userTypes.LOGIN_SUCCESS_USER:
    case userTypes.SIGNUP_SUCCESS_USER:
      return {...state, message: action.message, type: 'SUCCESS'};
    case DISMISS_MESSAGE:
      return {...state, message: '', type: 'SUCCESS'};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// app/modules/message.js